import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Heart } from "lucide-react";
import { toast } from "sonner";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "";
  }
}

export default function ThankYous() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/thank-yous");
        setMessages(data);
      } catch (e) {
        toast.error("Couldn't load your thank-yous.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="container-x py-12 lg:py-16" data-testid="thank-yous-page">
      <div className="max-w-2xl">
        <span className="tag-pill">Messages for you</span>
        <h1 className="mt-3 font-outfit text-3xl lg:text-4xl font-medium text-ink tracking-tight">
          Thank-yous
        </h1>
        <p className="mt-3 font-manrope text-ink-soft leading-relaxed">
          Notes from registry owners you've supported. You showed up — here's what that meant.
        </p>
      </div>

      {loading ? (
        <p className="mt-10 font-manrope text-ink-soft animate-soft-pulse">Loading…</p>
      ) : messages.length === 0 ? (
        <div className="mt-10 card-soft p-10 text-center" data-testid="thank-yous-empty">
          <Heart className="h-8 w-8 text-brand mx-auto mb-3 opacity-60" />
          <p className="font-outfit text-lg text-ink">No thank-yous yet.</p>
          <p className="font-manrope text-sm text-ink-soft mt-2 max-w-md mx-auto">
            When owners of registries you've supported send a note, it'll show up here.
          </p>
        </div>
      ) : (
        <div className="mt-10 grid gap-5 max-w-2xl">
          {messages.map((m) => (
            <div key={m.id} className="card-soft p-6" data-testid={`thank-you-${m.id}`}>
              <div className="flex items-center justify-between flex-wrap gap-2">
                <span className="tag-pill">From {m.from_user_name}</span>
                <span className="font-manrope text-xs text-ink-soft">{formatDate(m.created_at)}</span>
              </div>
              <p className="mt-4 font-manrope text-ink leading-relaxed">{m.message}</p>
              {m.item_name && (
                <p className="mt-3 font-manrope text-xs text-ink-soft">
                  For: <span className="text-brand font-medium">{m.item_name}</span>
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
